import type { Dependents, RegisterFormFields, RegisterFormType } from '@/modules/FinancialPlanning/interface/RegisterForm';
import type { FC } from 'react';
import { AddCircleOutline, Trash } from '@eqi-investimentos/icons/web';
import { Flex, Text } from '@eqi-investimentos/react';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { Button } from '@/components/atoms/Button';
import { GenericController } from '@/components/atoms/GenericController';
import { IconButton } from '@/components/atoms/IconButton';
import { IfRender } from '@/utils/jsx';
export const DependentsFields: FC<DependentsFieldsProps> = ({
  control,
  fields,
  errors
}) => {
  const {
    fields: controlFields,
    append,
    remove
  } = useFieldArray({
    control,
    name: 'dependents'
  });
  const handleDeleteDependent = (idx: number) => {
    remove(idx);
  };
  const handleCreateDependent = () => {
    append({
      name: '',
      gender: '',
      birthDate: NaN,
      kinship: ''
    });
  };
  return <Flex direction="column" gap={6} data-sentry-element="Flex" data-sentry-component="DependentsFields" data-sentry-source-file="DependentsFields.tsx">
      {[...Array(controlFields.length).keys()].map(idx => <Flex key={idx} gap={5} direction="column">
          <Flex justifyContent="space-between" alignItems="center" mb={2}>
            <Text>Dependente {idx + 1}</Text>
            <IfRender condition={idx > 0}>
              <IconButton ariaLabel="Deletar dependente" icon={Trash} iconProps={{
            color: 'black',
            boxSize: 5
          }} onButtonClick={() => handleDeleteDependent(idx)} />
            </IfRender>
          </Flex>
          {fields.map(({
        id,
        label,
        type,
        options
      }) => {
        const fieldId = id as keyof Dependents;
        return <GenericController<RegisterFormType> key={`dependents.${idx}.${fieldId}`} {...{
          name: `dependents.${idx}.${fieldId}`,
          label,
          options,
          errorMessage: errors.dependents?.[idx]?.[fieldId]?.message,
          control,
          type: type === 'number' ? 'text' : type
        }} />;
      })}
        </Flex>)}
      <Button variant="ghost" onClick={handleCreateDependent} data-sentry-element="Button" data-sentry-source-file="DependentsFields.tsx">
        <Text fontSize="sm" lineHeight={6} color="blackAlpha.800" data-sentry-element="Text" data-sentry-source-file="DependentsFields.tsx">
          Adicionar mais dependentes
        </Text>
        <AddCircleOutline color="brand.main" data-sentry-element="AddCircleOutline" data-sentry-source-file="DependentsFields.tsx" />
      </Button>
    </Flex>;
};
type DependentsFieldsProps = Pick<UseFormReturn<RegisterFormType>, 'control'> & {
  errors: UseFormReturn<RegisterFormType>['formState']['errors'];
  fields: RegisterFormFields[];
};